import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getTransactionStatus = createAsyncThunk(
  "transactionStatus/getTransactionStatus",
  async ({ token, transactionId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/checkout/sessions/${token}/transactions/${transactionId}/status`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  transactionStatusData: undefined,
  loading: false,
  error: null,
};

const transactionStatusSlice = createSlice({
  name: "transactionStatus",
  initialState,
  reducers: {
    resetTransactionStatus(state) {
      state.transactionStatusData = undefined;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.transactionStatusData = undefined;
      })
      .addCase(getTransactionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionStatusData = action.payload;
      })
      .addCase(getTransactionStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTransactionStatus } = transactionStatusSlice.actions;

export const selectTransactionData = (state) =>
  state.transactionStatus.transactionStatusData;

export const selectTransactionStatusLoading = (state) =>
  state.transactionStatus.loading;

export const selectTransactionStatusError = (state) =>
  state.transactionStatus.error;

export default transactionStatusSlice.reducer;


